import { Main } from '../components/Main/Main'

export const MainPage = () => {
    return <Main />
}
